import { FC } from "react";
import CustomButton from "../../UI/Buttons/CustomButton";
import Decline from "../../UI/Icons/Decline";
import RoundedTick from "../../UI/Icons/RoundedTick";
import PopupModal from "../../UI/Popup";

interface UnsavedChangesModalProps {
  visible: boolean;
  onLeave: () => void;
  onSave: () => void;
  onClose: () => void;
}

const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({ visible, onLeave, onSave, onClose }) => {
  
  return (
     <PopupModal visible={visible} showCloseBtn={true} onClickClose={onClose} customWidth={650}>
      <div className="d-flex flex-column gap-20">
        <div className="fs-22 text-black">Unsaved changes</div>
        <div className="fs-16 text-grey-medium">
          You are about to leave this page without saving.
        </div>

        <div className="d-flex gap-20 justify-content-end">
          <CustomButton
            variant={"primary"}
            type="button"
            className="btn-theme bg-half-white"
          onClick={onLeave}          >
            <Decline />
            {"Leave Without Saving"}
          </CustomButton>

          <CustomButton
            variant={"primary"}
            type="button"
            className="btn-theme bg-teal text-black"
            onClick={onSave}          >
            <RoundedTick />
            {"Save Changes"}
          </CustomButton>
        </div>
      </div>
    </PopupModal>
  );
};

export default UnsavedChangesModal;
